export default function ToBeImplemented() {
  return (
    <center>
      <h1>WORK IN PROGRESS</h1>
    </center>
  );
}
